module.exports = __webpack_public_path__ + "static/media/web.bad9c189.svg";